import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import Delete from "@mui/icons-material/Delete";

import resourceFactory from "common/admin/resourceFactory";
import SimpleSnackbar from "common/components/SimpleSnackbar";

// String to Array
export const stringToUniqueArray = (str, delimiter) => {
  return Array.from(
    uniqueArray(
      str
        .split(delimiter)
        .map((item) => item.trim())
        .filter((item) => item.length > 0),
    ),
  );
};

export const uniqueArray = (arr) => {
  return Array.from(new Set(arr));
};

const unitResource = resourceFactory("units");

export const UnitsModal = ({ selectedFloor, setSelectedFloor, reload }) => {
  const [units, setUnits] = useState("");
  const [list, setList] = useState([]);
  const [loadingList, setLoadingList] = useState(false);
  const [notification, setNotification] = useState("");

  useEffect(() => {
    getAll();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFloor]);

  useEffect(() => {
    notification && setTimeout(() => setNotification(""), 6000);
  }, [notification]);

  const getAll = () => {
    if (selectedFloor) {
      setLoadingList(true);

      unitResource
        .getAll({ floor_id: selectedFloor.id })
        .then(setList, (err) => {
          setNotification("Unable to fetch units");
          console.error(err);
        })
        .finally(() => setLoadingList(false));
    }
  };

  const handleUnits = () => {
    const uniqueArray = stringToUniqueArray(units, ",");

    const names = uniqueArray.filter((unit) =>
      list.every(({ name }) => name !== unit),
    );

    unitResource.create({ floor_id: selectedFloor.id, names }).then(
      () => {
        setNotification("Unit(s) created successfully!");
        getAll();

        reload();
      },
      (err) => {
        setNotification("Unable to create unit!");
        console.error(err);
      },
    );

    setUnits("");
  };

  return (
    <>
      {notification && <SimpleSnackbar message={notification} />}
      <Dialog
        fullWidth
        open={!!selectedFloor}
        onClose={() => setSelectedFloor(null)}
      >
        <DialogTitle>Assign units for Level {selectedFloor?.level}</DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            <Grid size={{ xs: 9 }}>
              <TextField
                fullWidth
                placeholder="Add a comma separated list of unit(s)"
                value={units}
                onChange={(e) => setUnits(e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 3 }}>
              <Button
                disabled={units.trim() === ""}
                variant="contained"
                color="primary"
                onClick={handleUnits}
              >
                Add unit(s)
              </Button>
            </Grid>
          </Grid>

          <Grid style={{ marginTop: "1rem" }} container spacing={3}>
            <Table fullWidth>
              <TableHead>
                <TableRow>
                  <TableCell align="center">ID</TableCell>
                  <TableCell align="center">Unit Name</TableCell>
                  <TableCell align="center">Remove?</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {loadingList || list.length === 0 ? (
                  <TableRow>
                    <TableCell align="center" colSpan={3}>
                      {loadingList ? "Loading units..." : "No units available"}
                    </TableCell>
                  </TableRow>
                ) : (
                  list.map(({ id, name }) => (
                    <TableRow key={id}>
                      <TableCell align="center">{id}</TableCell>
                      <TableCell align="center">{name}</TableCell>
                      <TableCell align="center">
                        <IconButton
                          onClick={() =>
                            unitResource
                              .removeOne(id, {
                                floor_id: selectedFloor.id,
                              })
                              .then(
                                () => {
                                  setList((oldList) =>
                                    oldList.filter(({ id: _id }) => _id !== id),
                                  );

                                  reload();
                                },
                                (err) => {
                                  console.error(err);
                                  setNotification("Unable to delete unit!");
                                },
                              )
                          }
                        >
                          <Delete />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};
